import {
    Box,
    Button,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
  } from "@mui/material";
  import React from "react";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
  
const MostViewGames = () => {
    const [days, setDays] = React.useState(10);
  const handleChange = (event) => {
    setDays(event.target.value);
  };
  return (
    <Grid container sx={{ marginLeft: "5%", marginTop: "3%" }} spacing={2}>
        <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          color: "#2f6df6",
        }}
      >
        <Box sx={{display:'flex',flexDirection:'row'}}>
        <Typography variant="h6">NEW RELEASES</Typography>
        <Box sx={{ width: '100px',color:'white',marginLeft:'5px' }}>
      <FormControl>
      <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          value={days}
          sx={{color:'white',fontSize:'10px'}}
          onChange={handleChange}
        >
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </FormControl>
    </Box>

        </Box>
        <Button sx={{ background: "transparent", border: "none" }}>
          View All
        </Button>
      </Grid>
     <Grid
        item
        xs={12} sm={12} md={12} lg={12} xl={12}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          marginLeft: "5px",
          marginRight: "5px",
          marginBottom: "5px",
          marginTop: "-1%",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <FavoriteRoundedIcon sx={{ color: "gray",fontSize:'medium' }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.87K
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <VisibilityRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>14.58K</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        xs={12} sm={12} md={12} lg={12} xl={12}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
          
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <FavoriteRoundedIcon sx={{ color: "gray",fontSize:'medium' }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.87K
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <VisibilityRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>14.58K</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        xs={12} sm={12} md={12} lg={12} xl={12}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
          
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <FavoriteRoundedIcon sx={{ color: "gray",fontSize:'medium' }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.87K
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <VisibilityRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>14.58K</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        xs={12} sm={12} md={12} lg={12} xl={12}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
          
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <FavoriteRoundedIcon sx={{ color: "gray",fontSize:'medium' }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.87K
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <VisibilityRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>14.58K</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
      <Grid
        item
        xs={12} sm={12} md={12} lg={12} xl={12}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flex: "100%",
          backgroundColor: "black",
          margin: "5px",
          
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <Box
            sx={{
              width: "60px",
              backgroundColor: "#2a2e4c",
              height: "60px",
              borderRadius: "5px",
            }}
          >
            <Typography></Typography>
          </Box>
          <Box>
            <Typography sx={{ marginLeft: "15px" }}>Metaspets</Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <FavoriteRoundedIcon sx={{ color: "gray",fontSize:'medium' }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                    5.87K
                  </Typography>
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem>
              <ListItemIcon>
                <VisibilityRoundedIcon sx={{ color: "gray" }} />
              </ListItemIcon>
              <ListItemText>
                <Typography sx={{ color: "gray" }}>14.58K</Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Grid>
    </Grid>
  )
}

export default MostViewGames